import { defineMessages } from 'react-intl'

const scope = 'procurify.expense.components.ExpenseReportForm'

export default defineMessages({
  expenseReportHeading: {
    id: `${scope}.expenseReportHeading`,
    defaultMessage: 'Expense report #{id} -',
  },
  titlePlaceholder: {
    id: `${scope}.titlePlaceholder`,
    defaultMessage: 'Expense title',
  },
  titleRequired: {
    id: `${scope}.titleRequired`,
    defaultMessage: 'Title is required',
  },
  requestedByLabel: {
    id: `${scope}.requestedByLabel`,
    defaultMessage: 'Requested by',
  },
  locationLabel: {
    id: `${scope}.locationLabel`,
    defaultMessage: '{singularPrimaryOrgCategoryLabel}',
  },
  departmentLabel: {
    id: `${scope}.departmentLabel`,
    defaultMessage: '{singularSecondaryOrgCategoryLabel}',
  },
  travelTicketLabel: {
    id: `${scope}.travelTicketLabel`,
    defaultMessage: 'Travel ticket',
  },
  travelTicketValue: {
    id: `${scope}.travelTicketValue`,
    defaultMessage: 'Travel #{id} - {purpose}',
  },
  nextApproverLabel: {
    id: `${scope}.nextApproverLabel`,
    defaultMessage: 'Next approver',
  },
  nextApproverRequired: {
    id: `${scope}.nextApproverRequired`,
    defaultMessage: 'Next approver is required',
  },
  submittedLabel: {
    id: `${scope}.submittedLabel`,
    defaultMessage: 'Submitted',
  },
  lastModifiedLabel: {
    id: `${scope}.lastModifiedLabel`,
    defaultMessage: 'Last modified',
  },
  expensePurposeHeading: {
    id: `${scope}.expensePurposeHeading`,
    defaultMessage: 'Expense purpose',
  },
  purposePlaceholder: {
    id: `${scope}.purposePlaceholder`,
    defaultMessage: 'Expense purpose',
  },
  purposeMaxLength: {
    id: `${scope}.purposeMaxLength`,
    defaultMessage: 'Purpose must be 2000 characters or less',
  },
  editExpenseLineMenuLabel: {
    id: `${scope}.editExpenseLineMenuLabel`,
    defaultMessage: 'Edit expense line',
  },
})
